module.exports = __webpack_public_path__ + "media/icons/camera--drawn-0b67c5aa.svg";